/** The minimal schema shape the extraction-schema resolver needs. */
export interface ResolvableSchema {
  id: string
  name: string
  version: number
  is_active: boolean
}

/**
 * The schema an extraction run will use, for read-only display in the Run
 * Extraction modal. Mirrors the server-side resolution (ADR-0004 / slice 02):
 * the case's bound schema wins; with no binding the case follows the globally
 * active schema; absent that, the first available. Null when none exist. A
 * binding that no longer resolves (stale/deleted) falls through to the active
 * schema so the modal still shows what will actually run.
 */
export function resolveExtractionSchema<T extends ResolvableSchema>(
  schemas: T[],
  boundSchemaId: string | null
): T | null {
  if (boundSchemaId) {
    const bound = schemas.find(schema => schema.id === boundSchemaId)
    if (bound) return bound
  }
  return schemas.find(schema => schema.is_active) ?? schemas[0] ?? null
}
